/** @format */

document.addEventListener("DOMContentLoaded", function () {
  const giftCheckbox =
    document.getElementById("gift-checkbox");
  const giftFields = document.getElementById("gift-fields");
  const recipientFirstName = document.getElementById(
    "recipient-first-name",
  );
  const recipientLastName = document.getElementById(
    "recipient-last-name",
  );
  const recipientEmail = document.getElementById(
    "recipient-email",
  );
  const recipientPhone = document.getElementById(
    "recipient-phone",
  );
  const giftMessage =
    document.getElementById("gift-message");
  const phoneErrorEl = document.getElementById(
    "recipient-phone-error",
  );

  if (!giftCheckbox || !giftFields || !recipientPhone) {
    console.error(
      "Gift checkbox/fields or phone input not found",
    );
    return;
  }

  /** Utils **/
  const ONLY_NUMS_AND_DASH = /^[\d-]*$/;
  const PHONE_PATTERN = /^\d{3}-\d{3}-\d{4}$/;

  function digitsOnly(str) {
    return (str || "").replace(/\D/g, "");
  }

  function formatUSPhoneProgressive(value) {
    // strip non-digits and cap at 10
    const d = digitsOnly(value).slice(0, 10);
    const len = d.length;
    if (len <= 3) return d;
    if (len <= 6) return d.slice(0, 3) + "-" + d.slice(3);
    return (
      d.slice(0, 3) + "-" + d.slice(3, 6) + "-" + d.slice(6)
    );
  }

  function isValidUSPhone(value) {
    return PHONE_PATTERN.test(value);
  }

  function showPhoneError(show) {
    if (!phoneErrorEl) return;
    phoneErrorEl.style.display = show ? "block" : "none";
    recipientPhone.setAttribute(
      "aria-invalid",
      show ? "true" : "false",
    );
    if (show) {
      recipientPhone.setAttribute(
        "aria-describedby",
        phoneErrorEl.id,
      );
    } else {
      recipientPhone.removeAttribute("aria-describedby");
    }
  }

  function setPhoneRequiredState(isRequired) {
    if (isRequired) {
      recipientPhone.setAttribute("required", "true");
    } else {
      recipientPhone.removeAttribute("required");
    }
  }

  /**
   * Fetch current cart attributes.
   */
  function fetchCurrentCartAttributes() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => cart.attributes || {})
      .catch((error) => {
        console.error(
          "Error fetching current cart attributes:",
          error,
        );
        return {};
      });
  }

  /**
   * Update cart attributes.
   * @param {Object} newAttributes - The new attributes to update in the cart.
   */
  function updateCartAttributes(newAttributes) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ attributes: newAttributes }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error(
          "Error updating cart attributes:",
          error,
        );
      });
  }

  /**
   * Populate fields based on current cart attributes.
   */
  function populateFieldsFromCartAttributes() {
    fetchCurrentCartAttributes().then(
      (currentAttributes) => {
        const isGift =
          currentAttributes["Is this a gift?"] === "Yes";
        giftCheckbox.checked = isGift;
        giftFields.style.display = isGift
          ? "block"
          : "none";
        setPhoneRequiredState(isGift);

        recipientFirstName.value =
          currentAttributes["Recipient First Name"] || "";
        recipientLastName.value =
          currentAttributes["Recipient Last Name"] || "";
        recipientEmail.value =
          currentAttributes["Recipient Email"] || "";

        // Normalize phone to our UI format if possible
        const rawPhone =
          currentAttributes["Recipient Phone"] || "";
        const normalized =
          formatUSPhoneProgressive(rawPhone);
        recipientPhone.value = normalized;
        showPhoneError(false);

        giftMessage.value =
          currentAttributes["Gift Message"] || "";
      },
    );
  }

  /**
   * Update cart attributes based on current field values.
   * (Will not push invalid phone.)
   */
  function updateCartAttributesFromFields() {
    const phoneVal = recipientPhone.value.trim();
    const isGift = giftCheckbox.checked;

    // If gift required and phone invalid, don't send phone; keep other fields
    const phoneForCart = isGift
      ? isValidUSPhone(phoneVal)
        ? phoneVal
        : ""
      : phoneVal; // if not gift, we can store whatever is present (but it's formatted anyway)

    const newAttributes = {
      "Is this a gift?": isGift ? "Yes" : "No",
      "Recipient First Name":
        recipientFirstName.value.trim(),
      "Recipient Last Name": recipientLastName.value.trim(),
      "Recipient Email": recipientEmail.value.trim(),
      "Recipient Phone": phoneForCart,
      "Gift Message": giftMessage.value.trim(),
    };

    updateCartAttributes(newAttributes);
  }

  /** Handlers **/

  // Toggle gift fields + required state
  function handleCheckboxChange() {
    const isGift = giftCheckbox.checked;
    giftFields.style.display = isGift ? "block" : "none";
    setPhoneRequiredState(isGift);

    if (!isGift) {
      // Clear gift-only fields & errors when toggled off
      recipientFirstName.value = "";
      recipientLastName.value = "";
      recipientEmail.value = "";
      recipientPhone.value = "";
      giftMessage.value = "";
      showPhoneError(false);
    }
    updateCartAttributesFromFields();
  }

  // Common handler for non-phone fields
  function handleFieldChange() {
    updateCartAttributesFromFields();
  }

  // Enforce only digits and '-' while typing (prevents other chars)
  function handlePhoneKeydown(e) {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
    ];
    const isCtrlCombo = e.ctrlKey || e.metaKey;

    if (
      allowedKeys.includes(e.key) ||
      isCtrlCombo // allow copy/paste/select-all shortcuts
    ) {
      return;
    }

    // Allow digits and dash
    if (!/^\d$/.test(e.key) && e.key !== "-") {
      e.preventDefault();
    }
  }

  // Format as user types, and live-update attributes
  function handlePhoneInput() {
    const cursorPos = recipientPhone.selectionStart;
    const before = recipientPhone.value;

    // If user pasted stuff, strip to only digits/dashes first
    if (!ONLY_NUMS_AND_DASH.test(before)) {
      recipientPhone.value = before.replace(/[^\d-]/g, "");
    }

    // Now format to 123-456-7890 style progressively
    const formatted = formatUSPhoneProgressive(
      recipientPhone.value,
    );
    recipientPhone.value = formatted;

    // Try to keep caret behavior sane (best-effort)
    try {
      if (typeof cursorPos === "number") {
        const delta =
          recipientPhone.value.length - before.length;
        recipientPhone.setSelectionRange(
          cursorPos + delta,
          cursorPos + delta,
        );
      }
    } catch {}

    showPhoneError(false);
    updateCartAttributesFromFields();
  }

  // Validate on blur: if invalid when gift is checked, clear + show error
  function handlePhoneBlur() {
    const isGift = giftCheckbox.checked;
    const val = recipientPhone.value.trim();

    if (isGift && val.length > 0 && !isValidUSPhone(val)) {
      recipientPhone.value = "";
      showPhoneError(true);
      updateCartAttributesFromFields();
      return;
    }

    // If gift & empty -> show error (required)
    if (isGift && val === "") {
      showPhoneError(true);
      updateCartAttributesFromFields();
      return;
    }

    // Valid or non-gift case
    showPhoneError(false);
    updateCartAttributesFromFields();
  }

  /** Event listeners **/
  giftCheckbox.addEventListener(
    "change",
    handleCheckboxChange,
  );

  [
    recipientFirstName,
    recipientLastName,
    recipientEmail,
    giftMessage,
  ].forEach((field) => {
    field.addEventListener("input", handleFieldChange);
  });

  // Phone-specific listeners
  recipientPhone.addEventListener(
    "keydown",
    handlePhoneKeydown,
  );
  recipientPhone.addEventListener(
    "input",
    handlePhoneInput,
  );
  recipientPhone.addEventListener("blur", handlePhoneBlur);

  // Initialize from cart
  populateFieldsFromCartAttributes();
});

class CartManager {
  constructor(cartItems, { debug = false } = {}) {
    this.cartItems = cartItems;
    this.tz = "America/New_York"; // ET (DST-aware). If you truly need fixed -05:00 always, tell me.
    this.debug = debug;
  }

  log(...args) {
    if (this.debug) console.log("[CartManager]", ...args);
  }

  validCartItems(items) {
    return Array.isArray(items) && items?.length > 0;
  }

  filterProgramsWithStartDate(items) {
    return items.filter(
      (item) =>
        item.properties && "Start Date" in item.properties,
    );
  }

  // -------------------------
  // Parse YYYY-MM-DD as an ET calendar date (weekday-safe)
  // -------------------------

  parseYMD(value) {
    if (typeof value !== "string") return null;
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    if (!y || mo < 1 || mo > 12 || d < 1 || d > 31)
      return null;
    return { y, mo, d };
  }

  // Weekday of a calendar date, invariant across timezones. 0=Sun..6=Sat Sunday is not a possible start date
  weekdayFromYMD({ y, mo, d }) {
    return new Date(Date.UTC(y, mo - 1, d)).getUTCDay();
  }

  // Shipment 2 dates = Thu/Fri/Sat
  isShipment2YMD(ymd) {
    const wd = this.weekdayFromYMD(ymd);
    return wd === 4 || wd === 5 || wd === 6;
  }

  // -------------------------
  // ET "now" + cutoff instant (no libs)
  // -------------------------

  // Get ET wall-clock parts for an instant
  getETParts(instant) {
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone: this.tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      weekday: "short",
    });

    const parts = dtf.formatToParts(instant);
    const map = {};
    for (const p of parts) map[p.type] = p.value;

    const weekdayMap = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };

    return {
      y: Number(map.year),
      mo: Number(map.month),
      d: Number(map.day),
      hh: Number(map.hour),
      mm: Number(map.minute),
      ss: Number(map.second),
      weekday: weekdayMap[map.weekday],
    };
  }

  /**
   * Convert an ET wall-clock (y,mo,d,hh,mm,ss) to a real instant.
   * DST-safe.
   */
  etWallClockToInstant({
    y,
    mo,
    d,
    hh = 0,
    mm = 0,
    ss = 0,
  }) {
    // Start with a UTC guess
    const guessUtc = new Date(
      Date.UTC(y, mo - 1, d, hh, mm, ss, 0),
    );

    // See what ET wall-clock that UTC guess corresponds to
    const got = this.getETParts(guessUtc);

    // Compute difference in minutes between intended and got (treat as same “timeline”)
    const intendedMinutes =
      hh * 60 + mm + y * 5256000 + mo * 44640 + d * 1440; // coarse but consistent
    const gotMinutes =
      got.hh * 60 +
      got.mm +
      got.y * 5256000 +
      got.mo * 44640 +
      got.d * 1440;

    // Use ms delta based on actual wall-clock components (more precise):
    const intended = Date.UTC(y, mo - 1, d, hh, mm, ss, 0);
    const gotAsIfUtc = Date.UTC(
      got.y,
      got.mo - 1,
      got.d,
      got.hh,
      got.mm,
      got.ss,
      0,
    );
    const deltaMs = intended - gotAsIfUtc;

    return new Date(guessUtc.getTime() + deltaMs);
  }

  /**
   * Next occurrence of cutoff weekday/time in ET, relative to now (in ET).
   * This is the thing your dropdown does (getNextInstanceOfDay).
   */
  getNextCutoffInstantFromNow(
    nowInstant,
    cutoffWeekday,
    cutoffHour = 12,
    cutoffMinute = 0,
  ) {
    const nowET = this.getETParts(nowInstant);

    const isSameDay = nowET.weekday === cutoffWeekday;
    const isBeforeCutoff =
      nowET.hh < cutoffHour ||
      (nowET.hh === cutoffHour && nowET.mm < cutoffMinute);

    const daysUntil =
      (cutoffWeekday - nowET.weekday + 7) % 7;
    const addWeek = isSameDay && !isBeforeCutoff ? 7 : 0;
    const totalDays = daysUntil + addWeek;

    // Build the target ET date by adding days to nowET's Y/M/D (in ET space)
    // We can safely use a UTC Date to add days, then read back Y/M/D, because we're only using it as a calendar increment helper.
    const helper = new Date(
      Date.UTC(nowET.y, nowET.mo - 1, nowET.d),
    );
    helper.setUTCDate(helper.getUTCDate() + totalDays);

    const targetY = helper.getUTCFullYear();
    const targetMo = helper.getUTCMonth() + 1;
    const targetD = helper.getUTCDate();

    return this.etWallClockToInstant({
      y: targetY,
      mo: targetMo,
      d: targetD,
      hh: cutoffHour,
      mm: cutoffMinute,
      ss: 0,
    });
  }

  /**
   * Business rule:
   * - Shipment 1 cutoff: Thu 12pm ET
   * - Shipment 2 cutoff: Sun 12pm ET
   * Invalid if now >= cutoffInstant
   */
  isInvalidByCutoffBucket(
    isShipment2,
    nowInstant,
    cutoffHour = 12,
    cutoffMinute = 0,
  ) {
    const cutoffWeekday = isShipment2 ? 0 : 4; // Sun : Thu
    const nowET = this.getETParts(nowInstant);

    // 0 = same day as cutoff, 1-3 = days AFTER cutoff, 4-6 = days BEFORE next cutoff
    const daysPastCutoff =
      (nowET.weekday - cutoffWeekday + 7) % 7;

    if (daysPastCutoff === 0) {
      // Same day: invalid only if at or past the cutoff time
      const isBeforeCutoff =
        nowET.hh < cutoffHour ||
        (nowET.hh === cutoffHour &&
          nowET.mm < cutoffMinute);
      return !isBeforeCutoff;
    }

    // 1–3 means we're past this week's cutoff day → invalid
    // 4–6 means the cutoff is still upcoming → valid
    return daysPastCutoff <= 3;
  }

  // Compute the exact cutoff instant that governs a specific start date.
  // For S1 (Mon/Tue/Wed): cutoff is the Thursday before it
  // For S2 (Thu/Fri/Sat): cutoff is the Sunday before it
  getCutoffForStartDate(ymd) {
    const isShipment2 = this.isShipment2YMD(ymd);
    const cutoffWeekday = isShipment2 ? 0 : 4; // Sun : Thu

    const startWeekday = this.weekdayFromYMD(ymd);
    const daysBack = (startWeekday - cutoffWeekday + 7) % 7;

    const helper = new Date(
      Date.UTC(ymd.y, ymd.mo - 1, ymd.d),
    );
    helper.setUTCDate(helper.getUTCDate() - daysBack);

    return this.etWallClockToInstant({
      y: helper.getUTCFullYear(),
      mo: helper.getUTCMonth() + 1,
      d: helper.getUTCDate(),
      hh: 12,
      mm: 0,
      ss: 0,
    });
  }

  checkStartDate(rawStartDate) {
    const ymd = this.parseYMD(rawStartDate);
    if (!ymd) return true; // invalid if we can't parse YYYY-MM-DD

    const now = new Date();
    const cutoffInstant = this.getCutoffForStartDate(ymd);
    const invalid =
      now.getTime() >= cutoffInstant.getTime();

    if (this.debug) {
      const isShipment2 = this.isShipment2YMD(ymd);
      this.log("checkStartDate", {
        rawStartDate,
        startDateWeekday: this.weekdayFromYMD(ymd),
        isShipment2,
        nowISO: now.toISOString(),
        nowET: this.getETParts(now),
        cutoffISO: cutoffInstant.toISOString(),
        cutoffET: this.getETParts(cutoffInstant),
        invalidBecauseNowPastCutoff: invalid,
      });
    }

    return invalid;
  }

  filterStartDates(items) {
    const mapped = items.map((item) => {
      const raw = item.properties["Start Date"];
      const isInvalid = this.checkStartDate(raw);
      return { ...item, is_invalid: isInvalid }; // non-mutating
    });

    return mapped.filter(
      (item) => item.is_invalid !== false,
    );
  }

  showError() {
    const errorDiv = document.querySelector(
      ".cart-template__error",
    );
    const checkoutButtons = document.querySelectorAll(
      ".cart-template__checkout-button",
    );

    if (errorDiv)
      errorDiv.classList.add(
        "cart-template__error--active",
      );
    if (checkoutButtons.length > 0)
      checkoutButtons.forEach(
        (cbtn) => (cbtn.disabled = true),
      );
  }

  hideError() {
    const errorDiv = document.querySelector(
      ".cart-template__error",
    );
    const checkoutButtons = document.querySelectorAll(
      ".cart-template__checkout-button",
    );

    if (errorDiv)
      errorDiv.classList.remove(
        "cart-template__error--active",
      );
    if (checkoutButtons.length > 0)
      checkoutButtons.forEach(
        (cbtn) => (cbtn.disabled = false),
      );
  }

  validateCartItems() {
    const isValidArr = this.validCartItems(this.cartItems);
    if (!isValidArr) return null;

    const cartItemWithStartDate =
      this.filterProgramsWithStartDate(this.cartItems);
    if (cartItemWithStartDate.length > 0) {
      const invalidItemsInCart = this.filterStartDates(
        cartItemWithStartDate,
      );
      if (
        invalidItemsInCart &&
        invalidItemsInCart.length > 0
      ) {
        this.showError();
        return {
          hasInvalidItems: true,
        };
      } else {
        this.hideError(); // all valid programs
        return {
          hasInvalidItems: false,
        };
      }
    } else {
      this.hideError(); // no programs in cart
    }

    return {
      hasInvalidItems: false,
    };
  }

  calculateTotalQuantity() {
    return this.cartItems.reduce(
      (total, item) => total + item.quantity,
      0,
    );
  }
}
